"use strict";function showCallMenu$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.showCallMenu$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.telephone.showCallMenu";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.showCallMenu$=showCallMenu$,exports.default=showCallMenu$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/telephone/showCallMenu.js
// module id = 997
// module chunks = 106